import { render, staticRenderFns } from "./LinkPayForm.vue?vue&type=template&id=611377dc&"
import script from "./LinkPayForm.vue?vue&type=script&lang=ts&"
export * from "./LinkPayForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports